import BaseHelpers from '@/plugins/baseHelpers';

/* Limita o input do usuário a keys que passem no RegEx */
const preventUnwantedKeydown = (event, test,) => {
  const controlKeys = ['Backspace', 'Tab', 'Enter', 'Shift', 'Control', 'Alt', 'Meta',];
  const regex = new RegExp(String.raw`^${test.source}+$`,);
  const { key, } = event;
  const hasModifier = (event.crtlKey || event.metaKey || event.shiftKey);
  const isValidKey = regex.test(key,);

  if (!isValidKey && !controlKeys.includes(key,) && !hasModifier) {
    event.preventDefault();
  }
};

export default {
  install: (Vue, store,) => {
    Vue.directive('permission', {
      bind: (el, binding,) => {
        if (!store.getters['user/user'].
          permissions.find((item,) => item.name === binding.value,)) {
          el.style.display = 'none';
        }
      },
    },);

    Vue.directive('keys-restricted-to', {
      bind: (el, { value, },) => {
        if (BaseHelpers._toRawType(value,) === 'RegExp') {
          el.addEventListener('keydown', (evt,) => preventUnwantedKeydown(evt, value,),);
        }
      },
      update: (el, { value, },) => {
        const currentValue = el.value || '';
        if (BaseHelpers._toRawType(value,) === 'RegExp' && currentValue) {
          const regex = new RegExp(String.raw`${value.source}+`, 'g',);
          el.value = (currentValue.match(regex,) || []).join``;
          el.dispatchEvent(new Event('change',),);
        }
      },
      unbind: (el, { value, },) => {
        if (BaseHelpers._toRawType(value,) === 'RegExp') {
          el.removeEventListener('keydown', (evt,) => preventUnwantedKeydown(evt, value,),);
        }
      },
    },);
  },
};
